var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-attendance-table-component" },
    [
      _c("div", { staticClass: "room-attendance-table-wrapper" }, [
        _c("table", { staticClass: "room-attendance-table" }, [
          _vm._m(0),
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("common.name")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("attendance.modal.nowEntered")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("attendance.list.init")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("attendance.list.last")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("attendance.list.total")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("attendance.list.kickCount")))]),
              _c("th", [_vm._v("Email")]),
            ]),
          ]),
        ]),
      ]),
      _c("perfect-scrollbar", [
        _c("div", { staticClass: "room-attendance-table-wrapper body" }, [
          _c("table", { staticClass: "room-attendance-table" }, [
            _c("colgroup", [
              _c("col", { attrs: { width: "4%" } }),
              _c("col", { attrs: { width: "4%" } }),
              _c("col", { attrs: { width: "6%" } }),
              _c("col", { attrs: { width: "6%" } }),
              _c("col", { attrs: { width: "4%" } }),
              _c("col", { attrs: { width: "4%" } }),
              _c("col", { attrs: { width: "7%" } }),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.attendanceList, function (attendance, i) {
                return _c("tr", { key: i }, [
                  _c(
                    "td",
                    {
                      staticClass: "bold",
                      class: { me: attendance.userId === _vm.me.userId },
                    },
                    [_vm._v(_vm._s(attendance.nickname || attendance.username))]
                  ),
                  _c("td", [_vm._v(_vm._s(attendance.present ? "O" : "X"))]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.getFormedDate(attendance.firstEnter))),
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        !attendance.lastLeave
                          ? "-"
                          : _vm.getFormedDate(attendance.lastLeave)
                      )
                    ),
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.getDurationDate(attendance.totalAttendingSeconds)
                      )
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(attendance.kickCount))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        attendance.email || _vm.$t("attendance.modal.nonMember")
                      )
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "6%" } }),
      _c("col", { attrs: { width: "6%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "7%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }